export default __webpack_public_path__ + "static/media/icon_mydata_korea_child.c52d4054.svg";